module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-700.65a568f.woff2";